import { Injectable } from '@angular/core';

import { Model } from '../shared/model'
import { User } from '../user/user.model';

@Injectable()
export class Organization extends Model {

  // properties
  id                  : number
  name                : string
  company             : string
  address1            : string
  address2            : string
  ancestors           : string
  city                : string
  country             : string
  hologram_org_id     : string
  logo_storage_url    : string
  logo_url            : string
  logo                : any
  parent_id           : number
  phone               : string
  province            : string
  type                : string
  tz                  : string
  zip                 : string

  users               : User[]

  constructor(obj: Organization) {
    super(obj);
    Object.assign(this, obj);
  }
}
